import { mapGetters, mapMutations, mapActions } from 'vuex';
import mvtInputGeo from '@/common/components/mvtinputgeo/mvt-inputgeo.vue';
import { getPathBySearchObj } from '../../../../widget/spec/searchHelper';
import mvtRadio from '@/common/components/mvtradio/mvt-radio.vue';
import { setStorage, getStorage } from '../../../common/utilities/nojq/_localstorage.js';

const isSSR = typeof window === 'undefined';

export default {
    name: 'name',
    inject: ['$eventBus'],
    computed: {
        ...mapGetters('glb', ['glb']),
    },
    components: {
        mvtInputGeo,
        mvtRadio,
    },
    data() {
        return {
            componentMounted: false,
            commuteRadius: null,
            commuteData: [
                {
                    text: '2 Mi',
                    labelText: '2 Miles',
                    value: 2,
                },
                {
                    text: '5 Mi',
                    labelText: '5 Miles',
                    value: 5,
                },
                {
                    text: '10 Mi',
                    labelText: '10 Miles',
                    value: 10,
                },
                {
                    text: '20 Mi',
                    labelText: '20 Miles',
                    value: 20,
                },
                {
                    text: '30 Mi',
                    labelText: '30 Miles',
                    value: 30,
                },
            ],
            geoInfo: {
                text: '',
                geo: null,
            },
        };
    },
    methods: {
        getSearchUrlByGeo(geo) {
            let filter;
            if (this.glb.rentals) {
                filter = {
                    rentals: 1,
                };
            }
            return getPathBySearchObj(geo, filter);
        },
        initalCommuteSearch(opt) {
            if (opt && this.geoInfo.geo) {
                const to = opt.to.path.split('/')[1];
                if (getStorage('commuteInfoInMSP') && to !== getStorage('commuteInfoInMSP').commutePath) {
                    this.geoInfo.geo = null;
                    this.geoInfo.text = '';
                    this.commuteRadius = null;
                    setStorage('commuteInfoInMSP', null);
                }
            }
        },
    },
    mounted() {
        this.componentMounted = true;
        if (getStorage('commuteInfoInMSP') && this.$route.path.includes('address-')) {
            var commuteInfo = getStorage('commuteInfoInMSP');
            this.geoInfo.text = commuteInfo.text;
            this.geoInfo.geo = commuteInfo.geo;
        } else {
            setStorage('commuteInfoInMSP', null);
        }
        this.$eventBus.$on('eventbus-page-update', this.initalCommuteSearch);
        this.$eventBus.$on('eventbus-filter-reset', () => {
            this.commuteRadius = null;
        });
    },
    watch: {
        geoInfo(newVal) {
            if (newVal) {
                var params = {
                    text: newVal.text,
                    geo: newVal.geo,
                };
                if (newVal.geo && newVal.geo.address_components) {
                    var isGoogleGeo = newVal.geo.address_components.reduce(function (prev, next) {
                        if (prev) {
                            return prev;
                        } else if (next.types.indexOf('street_number') >= 0) {
                            return true;
                        }
                        return false;
                    }, false);
                    if (isGoogleGeo) {
                        this.commuteRadius = null;
                        if (params.geo) {
                            params.geo.searchType = 'COMMUTE';
                        }
                        const path = this.getSearchUrlByGeo(params.geo, params.text);
                        var commuteInfoStorage = {
                            commutePath: path[0] === '/' ? path.split('/')[1] : path.split('/')[0],
                            text: params.text,
                            geo: params.geo,
                        };
                        setStorage('commuteInfoInMSP', commuteInfoStorage);
                        this.$router.push({ path: `/${path}` });
                    } else {
                        this.$eventBus.$emit('dialog-center', { name: 'mvtGeoSearchResult', trigger: this.$options.name, opt: {} });
                        this.geoInfo.geo = null;
                    }
                }
            }
        },
        commuteRadius(newVal) {
            if (newVal) {
                if (this.geoInfo.geo) {
                    const geoInfo = JSON.parse(JSON.stringify(this.geoInfo));
                    const commutePayload = {
                        radius: newVal,
                        lat: geoInfo.geo.geometry.location.lat,
                        lng: geoInfo.geo.geometry.location.lng,
                    };
                    this.$eventBus.$emit('eventbus-expandsearch-nearby', commutePayload);
                } else {
                    this.$eventBus.$emit('eventbus-expandsearch-nearby', { radius: newVal });
                }
            }
        },
    },
};
